/**
 * 罐頭訊息（主計劃 P0-3）。審核核准/退回時可快速選用的制式理由。
 * ⚠️ 內容為預設值，待需求書/客戶確認後調整用語。
 */
export const APPROVE_MESSAGES = [
  "資料正確，同意。",
  "已確認附件與欄位，核准。",
  "符合規範，通過。",
];

export const REJECT_MESSAGES = [
  "欄位資訊不完整，請補齊後重送。",
  "與現有資料衝突，請確認。",
  "缺少必要附件或佐證，退回。",
  "不符合命名/編號規範，請修正。",
];
